import React, { Component } from 'react';
import { QueryRenderer } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';

import withStyles from '@mui/styles/withStyles';
import { Button, FormControl, FormControlLabel, Switch, Grid, InputLabel, MenuItem, Paper, Select, Snackbar, SnackbarContent, Table, TableHead, TableCell, TableBody, TableRow, TextField, Tooltip, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import ServerError from '../ui/ServerError';
import SearchField from '../ui/SearchField';
import CreatePayoutsFetch from './CreatePayoutsFetch';

import { addDays, format, isValid, startOfDay, subMonths } from 'date-fns';

import PageTitle from '../ui/PageTitle';
import ConfirmationDialog from '../ui/ConfirmationDialog';
import LoadingSpinner from '../ui/LoadingSpinner';
import SavingSpinner from '../ui/SavingSpinner';
import classNames from 'classnames';
import AppBindStyles from '../../AppBindStyles';

import { green } from '@mui/material/colors';


const abEnvironment = new AbEnvironment();

const CreatePayoutsQuery = graphql`
query CreatePayoutsQuery($vendoraccountId: UUID!, $startDate: Datetime, $endDate: Datetime, $accountName: String, $showHistory: Int, $programType: Int, $first: Int, $offset: Int) {
  getcreatepayoutinfo2(vendoraccountid : $vendoraccountId, startTs:  $startDate, endTs: $endDate, accountname: $accountName, showhistory: $showHistory, programtype: $programType, first: $first, offset: $offset) { 
    totalCount 
    nodes { 
      resellerPid
      programName
      programDescription
      programType
      resellerAccountId
      resellerAccountName
      payoutStatus
      payoutCreatedDate
      periodStartTs
      periodEndTs
      approvedDate
      approvedBy
    } 
  } 
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
    //marginTop: 10,
    justifyContent: 'flex-end',
    backgroundColor: theme.palette.background.default,
  },
  flex: {
    flex: 1,
  },
  paper: {
    maxWidth: 1200,
    marginTop: '16px'
  },
  success: {
    backgroundColor: green[300],
  },
  error: {
    backgroundColor: theme.palette.error.light,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  close: {
    padding: theme.spacing(0.5),
  },
  nselect: {
    minWidth: 150
  }
});

class CreatePayouts extends Component {


  constructor(props) {
    super(props);

    let payoutToDate = new Date();
    let tDate = localStorage.getItem('cpayoutToDate');
    if (tDate != null) {
      payoutToDate = new Date(tDate);
    }
    //search todate should be "start of next day"
    let payoutToDateUtc = startOfDay(addDays(payoutToDate, 1)).toISOString();

    let payoutFromDate = new Date();
    let fDate = localStorage.getItem('cpayoutFromDate');
    if (fDate != null) {
      payoutFromDate = new Date(fDate);
    } else {
      payoutFromDate = subMonths(payoutToDate, 1);
    }
    //search todate should be "start of next day"
    let payoutFromDateUtc = startOfDay(payoutFromDate).toISOString();

    this.state = {

      showSpinner: false,
      showNotificationSpinner: false,
      saveStatus: null,
      saveMessage: null,
      snackbarOpen: false,
      snackbarDuration: null,

      showHistory: 0,
      accountName: null,
      startDate: payoutFromDate,
      queryStartDateUtc: payoutFromDateUtc,
      endDate: payoutToDate,
      queryEndDateUtc: payoutToDateUtc,
      createConfirm: false,
      createAllConfirm: false,
      confirmSendNotification: false,
      resellerPIdToCreate: null,
      programType: null,
      availableProgramTypes: [],
      reFetch: 0,
      page: 0,
      rowsPerPage: 10,
    };  
  }

  /*
   * Need to find all the possible program types for this vendor.  This displays in a select list.
   * and controls button behavior
   */
    componentDidMount() {
      const params = new URLSearchParams(this.props.location.search);
      let acctId = params.get('accountId');
   
      CreatePayoutsFetch.fetch(acctId).toPromise()
      .then(cpf => {
        let programs = cpf.accountTByAccountId.cpTsByAccountId.nodes;
        let availableProgramTypes = [];
        let i = 0;
        for (i = 0; i < programs.length; i++) {
          let program = programs[i];
          if (!availableProgramTypes.includes(program.programType)) {
            availableProgramTypes.push(program.programType);
          }
        }
        this.setState({availableProgramTypes: availableProgramTypes, programType: availableProgramTypes[0]});
        
        
      }).catch(err => {
        // Nothing to do
      });
    }
  
 
  goTo(route) {
 
    this.props.history.push(`/${route}`);
  }

  confirmCreate(resellerPId) {
    this.setState({createConfirm: true, resellerPIdToCreate: resellerPId});
  }
  confirmAllCreate() {
    this.setState({createAllConfirm: true});
  }
  confirmSendNotification() {
    this.setState({confirmSendNotification: true});
  }


  handleChange = name => event => {
    this.setState({[name]: event.target.value,
    page: 0,});
  };


  handleChangePage = (event, page) => {
    this.setState({page: page});
  }
  
  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value, page: 0});
  }

  setFromDate(theDate) {
    let start = new Date(theDate);
    if (isValid(start)) {
      localStorage.setItem('cpayoutFromDate', start);
      let startDateUtc = startOfDay(start).toISOString();
      this.setState({ startDate: start, queryStartDateUtc: startDateUtc, page : 0 });
    }
  }

  setToDate(theDate) {
    let end = new Date(theDate);
    if (isValid(end)) {
      localStorage.setItem('cpayoutToDate', end);
      let endDateUtc = startOfDay(addDays(end, 1)).toISOString();
      this.setState({ endDate: end, queryEndDateUtc: endDateUtc, page : 0 });
    }
  }

  areDatesValid() {
    if (this.state.programType === 0) {
      if (!this.state.startDate || !this.state.endDate) {
        return false;
      }
      //make sure same day for instant type
      if (format(this.state.startDate, 'MM/dd/yyyy') !==  format(this.state.endDate, 'MM/dd/yyyy') ) {
        return false;
      }
      //todo = validate 3 days ago.
    }
    return true;

  }

  handleSnackbarClose = (event, reason) => { 
    this.setState({ snackbarOpen: false, saveStatus: '', saveMessage: '' });
  };

  showSpinner() {
    return this.state.showSpinner;
  }

  showNotificationSpinner() {
    return this.state.showNotificationSpinner;
  }

  render() {
    const { isAuthenticated, isAuthenticatedAppBind, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    let rowCount = 0;

    const params = new URLSearchParams(this.props.location.search);
    let acctId = params.get('accountId');



    // Experiences for different personas...
    if (!isAuthenticated() || needAssent()) { 
      return ( <Redirect to='/home' /> );
    } else if (isAuthenticatedAppBind()) {

      let programTypeString = '';
      if (this.state.programType === 0) {
        programTypeString = ' for instant plans.'
      } else if (this.state.programType === 1) {
        programTypeString = ' for monthly rebate plans.'
      } else if (this.state.programType === 2) {
        programTypeString = ' for monthly credit plans.'
      } else if (this.state.programType === 3) {
        programTypeString = ' for prepaid credit plans.'
      } else if (this.state.programType === 4) {
        programTypeString = ' for referral plans.'
      }

      return (
        <Grid container spacing={3} direction="row" justifyContent="flex-start">
          <Grid item xs={12}>
            <PageTitle title="Create payouts" subtitle="Create payouts for one or more reseller." showBackButton={true} name="Vendor" noMargin={true} history={this.props.history}/>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={1} direction="row" justifyContent="flex-start">
              <Grid item>
                <div style={AppBindStyles.datePickerField}>
                <DatePicker
                  maxDateMessage={AppBindStyles.datePickerMessageMax}
                  autoOk
                  label="From date"
                  value={this.state.startDate}
                  onChange={(date) => this.setFromDate(date) }
                  format="YYYY-MM-DD"
                  disableFuture
                  renderInput={(params) => <TextField {...params} />}
                />
                </div>
              </Grid>
              <Grid item>
                <div style={AppBindStyles.datePickerField}>
                <DatePicker
                  maxDateMessage={AppBindStyles.datePickerMessageMax}
                  autoOk
                  label="To date"
                  value={this.state.endDate}
                  onChange={(date) => this.setToDate(date) }
                  format="YYYY-MM-DD"
                  disableFuture
                  renderInput={(params) => <TextField {...params} />}
                />
                </div>
              </Grid>
              <Grid item>
                <SearchField
                  id="reseller-name-search"
                  label="Search by reseller name"
                  value={this.state.accountName ? this.state.accountName : ''}
                  onChange={this.handleChange('accountName')}
                />
              </Grid>
              {this.state.programType !== null &&
              <Grid item>
                <FormControl variant="standard" >
                  <InputLabel shrink htmlFor="programType"></InputLabel>
                  <Select
                    value={this.state.programType}
                    inputProps={{
                      name: 'programType',
                      id: 'programType',
                    }}
                    onChange={(e) => { this.setState({ programType: e.target.value, page : 0}); } }
                    className={classes.nselect}
                  >
                    {this.state.availableProgramTypes.map(n => {
                        if (n === 0) {
                          return (<MenuItem value={n} key={n}>Instant rebate</MenuItem>);
                        } else if (n === 1) {
                          return (<MenuItem value={n} key={n}>Monthly rebate</MenuItem>);
                        } else if (n === 2) {
                          return (<MenuItem value={n} key={n}>Monthly credits</MenuItem>);
                        } else if (n === 3) { 
                          return (<MenuItem value={n} key={n}>Prepaid credits</MenuItem>);
                        } else if (n === 4) { 
                          return (<MenuItem value={n} key={n}>Referral</MenuItem>);
                        } else {
                          return (<MenuItem value={n} key={n}>Unknown type</MenuItem>);
                        }
                    })}
                  </Select>
                </FormControl>
              </Grid>
              }
              <Grid item>
                <FormControlLabel style={{marginLeft: '8px', marginTop: '8px'}}
                  control={
                    <Switch checked={this.state.showHistory === 1}
                      onChange={(e, checked) => {
                        if (checked) {
                          this.setState({ showHistory: 1, page : 0});
                        } else {
                          this.setState({ showHistory: 0, page : 0});
                        }
                      }}
                    />
                  }
                  label={'Show history'}
                />
              </Grid>

              <Grid item style={{marginTop:12}}>
                {!this.showNotificationSpinner() &&
                <Button color="primary"
                      variant="outlined"
                      onClick={() => { this.confirmSendNotification();}}>
                  Send vendor notification
                </Button>
                }
                {this.showNotificationSpinner() &&
                <Button disabled={true} color="primary" variant="outlined" >
                  <SavingSpinner/>
                </Button> 
                }
              </Grid>
              <Grid item style={{marginTop:12}}>
                {!this.showSpinner() &&
                <Button color="primary"
                      variant="outlined"
                      disabled={this.state.programType === null || !this.areDatesValid()}
                      onClick={() => { this.confirmAllCreate();}}>
                  Create All
                </Button>
                }
                {this.showSpinner() &&
                <Button disabled={true} color="primary" variant="outlined" >
                  <SavingSpinner/>
                </Button> 
                }
              </Grid>
              <Grid item xs={12}>
                <QueryRenderer
                  environment={abEnvironment.getEnvironment()}
                  query={CreatePayoutsQuery}
                  variables={{vendoraccountId: acctId,
                              startDate: this.state.queryStartDateUtc,
                              endDate: this.state.queryEndDateUtc,
                              accountName: this.state.accountName,
                              showHistory: this.state.showHistory,
                              programType: this.state.programType,
                              reFetch: this.state.reFetch}}
                  render={({error, props})=> {
                    if (error) {
                      logError(error.message);
                      return (
                        <ServerError/>
                      );
                    } else if (props) {
                      return (
                        <React.Fragment>
                          <Paper >
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell>Reseller</TableCell>
                                  <TableCell>Program</TableCell>
                                  <TableCell>Description</TableCell>
                                  <TableCell>Payout status</TableCell>
                                  <TableCell>Payout created</TableCell>
                                  <TableCell>Payout approved</TableCell>
                                  <TableCell>Start</TableCell>
                                  <TableCell>End</TableCell>
                                  <TableCell  align="center"></TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>

                              { !props.getcreatepayoutinfo2 ? '' : props.getcreatepayoutinfo2.nodes.map(n => {
                                  let disableCreate = true;
                                  if (n.payoutStatus == null || n.payoutStatus === '') {
                                    disableCreate = false;
                                  } 

                                  let pCreatedDate = ''; 
                                  let pStartDate = '';
                                  let pEndDate   = '';

                                  //dates are timestamp without timezone, add 'Z' to translate to local time (if desired)
                                  if (n.payoutCreatedDate) {
                                    pCreatedDate = format(new Date(n.payoutCreatedDate), 'yyyy-MM-dd'); 
                                  }
                                  if (n.periodStartTs) {
                                    pStartDate = format(new Date(n.periodStartTs), 'yyyy-MM-dd');
                                  }
                                  if (n.periodEndTs) {
                                    pEndDate   = format(new Date(n.periodEndTs), 'yyyy-MM-dd');
                                  }

                                  let pApprovedDate = '';
                                  if (n.approvedDate != null) {
                                    pApprovedDate = format(new Date(n.approvedDate), 'yyyy-MM-dd');
                                  } else if (n.autoPayout === 1) {
                                    //auto approved payouts do not have a time and date...use created
                                    pApprovedDate = format(new Date(n.payoutCreatedDate), 'yyyy-MM-dd');
                                  }

                                  let pApprovedBy = '';
                                  if (n.approvedBy != null) {
                                    pApprovedBy = 'Approved by ' + n.approvedBy;
                                  }

                                  // Reseller, Program (tooltip desc), Payout status, Payout created (date, by),
                                  // Payout approved (date, by), start, end 
                                  return (
                                    <TableRow key={rowCount++}>
                                      <TableCell>{n.resellerAccountName}</TableCell>
                                      <TableCell>{n.programName}</TableCell>
                                      <TableCell>{n.programDescription}</TableCell>
                                      <TableCell>{n.payoutStatus}</TableCell>
                                      <TableCell>{pCreatedDate}</TableCell>
                                      <TableCell><Tooltip title={pApprovedBy}><div>{pApprovedDate}</div></Tooltip></TableCell>
                                      <TableCell>{pStartDate}</TableCell>
                                      <TableCell>{pEndDate}</TableCell>
                                      <TableCell>
                                          {!disableCreate &&
                                          <Button color="primary"
                                                  variant="outlined"
                                                  disabled={this.state.programType === null || !this.areDatesValid()}
                                                  onClick={() => { this.confirmCreate(n.resellerPid);}}>
                                              Create
                                          </Button>
                                        }
                                      </TableCell>      
                                  </TableRow>
                                  );

                              })}
                              </TableBody>
                            </Table>

                            <ConfirmationDialog
                                  open={this.state.confirmSendNotification}
                                  onClose={() => { this.setState({confirmSendNotification:false});}}
                                  onConfirm={() => {this._sendNotification() }}
                                  onCancel={() => { }}
                                  title="Send notification to vendor?"
                                  cancelBtn="Cancel"
                                  okBtn="Ok"
                                  irreversibleAction={true}
                                >
                                  {'Are you sure you wish to send notification to vendor that one or more payouts are ready to be approved?'}
                            </ConfirmationDialog>  


                            <ConfirmationDialog
                                  open={this.state.createAllConfirm}
                                  onClose={() => { this.setState({createAllConfirm:false});}}
                                  onConfirm={() => {this._createPayoutAll(acctId) }}
                                  onCancel={() => { }}
                                  title="Create ALL payout?"
                                  cancelBtn="Cancel"
                                  okBtn="Ok"
                                  irreversibleAction={true}
                                >
                                  {'If you proceed, the payouts will be generated for range ' + this.state.queryStartDateUtc + ' - ' + this.state.queryEndDateUtc + programTypeString + ' for ALL resellers'}
                            </ConfirmationDialog>  

                            <ConfirmationDialog
                                  open={this.state.createConfirm}
                                  onClose={() => { this.setState({createConfirm:false});}}
                                  onConfirm={() => {this._createPayout() }}
                                  onCancel={() => { }}
                                  title="Create payout?"
                                  cancelBtn="Cancel"
                                  okBtn="Ok"
                                  irreversibleAction={true}
                                >
                                  {'If you proceed, this payout will be generated for range ' + this.state.queryStartDateUtc + ' - ' + this.state.queryEndDateUtc + programTypeString}
                            </ConfirmationDialog>  
                          </Paper>

                          <Snackbar
                              anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                              }}
                              open={this.state.snackbarOpen}
                              autoHideDuration={this.state.snackbarDuration}
                              onClose={this.handleSnackbarClose}
                          >
                            <SnackbarContent
                              className={classNames(classes.message, classes[this.state.saveStatus])}
                              onClose={this.handleSnackbarClose}
                              message={
                                <Typography variant="body1">
                                    {this.state.saveMessage}
                                </Typography>
                              }
                              action={[
                                <IconButton
                                  key="close"
                                  aria-label="Close"
                                  color="inherit"
                                  className={classes.close}
                                  onClick={this.handleSnackbarClose}
                                  size="large">
                                  <CloseIcon/>
                                </IconButton>
                              ]}
                            />
                          </Snackbar>
                        </React.Fragment>
                      );
                    }
                    return (
                      <div>
                        <Typography>Loading...</Typography>
                        <LoadingSpinner/>
                      </div>
                    );
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      );
    } else {
      return (
        <Redirect to='/home' />
      );
    }
  }

  _sendNotification() {
    const { callPartnerApi } = this.props.auth;

    this.setState({showNotificatonSpinner: true});
    
    const params = new URLSearchParams(this.props.location.search);
    let acctId = params.get('accountId');
   
    let aPjwt = abEnvironment.getPjwt();
    let theBody = 'One or more payouts have been created for your resellers.'

    // alert('Do a transfer from ' + abEnvironment.getUserAttribute('a_accountName') + ' to ' + customerName);

    let payload = {
      operation: "createNotification",
      params: {
        pJwt:             aPjwt,
        accountId:        acctId,
        notificationType: 'payouts',
        severity:         'Info',
        subject:          'Payouts created',
        body:             theBody
      }
    }
    
    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    )
    .then(response => {
      this.setState({showNotificatonSpinner: false});
    })
    .catch(error => {
      this.setState({showNotificatonSpinner: false});
    });

  }

  _createPayout = () => {

    const { callPartnerApi } = this.props.auth;

    this.setState({saveStatus: 'saving'});

    let aPjwt = abEnvironment.getPjwt();
 
    let payload = {
      operation: "createVendorResellerPayout2",
      params: {
        pJwt: aPjwt,
        vendorAccountId: null,
        resellerAccountId: null,
        resellerPId: this.state.resellerPIdToCreate,
        programType: this.state.programType,
        startDate: this.state.queryStartDateUtc,
        endDate: this.state.queryEndDateUtc
      }
    };

    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    )
    .then(resp => {
      return resp.json();
    })
    .then(response => {
      let json = JSON.parse(response);
      let fetch = this.state.reFetch;
      fetch++;

      let payoutResponse = json.data.createvendorresellerpayout.createVrPayoutReturns;
      if (payoutResponse.length > 0) {
        this.setState({ reFetch: fetch, snackbarOpen: true, saveStatus: 'success', saveMessage: 'Payout created', snackbarDuration: 3000 });
      } else {
        this.setState({ reFetch: fetch, snackbarOpen: true, saveStatus: 'success', saveMessage: 'Process ran but no payouts were created', snackbarDuration: 3000 });
      }

    })
    .catch(error => {
      //console.log(error);

      this.setState({ snackbarOpen: true, saveStatus: 'error', saveMessage: error, snackbarDuration: null });
    });
 
  }

  _createPayoutAll = (vendorAccountId) => {

    const { callPartnerApi, logError } = this.props.auth;

    this.setState({showSpinner: true});

    let aPjwt = abEnvironment.getPjwt();
 
    let payload = {
      operation: "createVendorAllResellerPayout2",
      params: {
        pJwt: aPjwt,
        vendorAccountId: vendorAccountId,
        programType: this.state.programType,
        startDate: this.state.queryStartDateUtc,
        endDate: this.state.queryEndDateUtc
      }
    };

    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    )
    .then(resp => {
      return resp.json();
    })
    .then(response => {
      if (response.payoutCount === -1) {
        throw response.message;
      } else if (response.payoutCount === 0) {
        this.setState({ showSpinner: false, snackbarOpen: true, saveStatus: 'error', saveMessage: 'Process completed but no resellers needed payouts.', snackbarDuration: null });
        return;
      }
      
      //let json = JSON.parse(response);
      let fetch = this.state.reFetch;
      fetch++;

      this.setState({ reFetch: fetch, showSpinner: false, snackbarOpen: true, saveStatus: 'success', saveMessage: response.message, snackbarDuration: 3000 });
    })
    .catch(error => {
      logError('Exception in CreatePayouts.js: ' + error);
      this.setState({ showSpinner: false, snackbarOpen: true, saveStatus: 'error', saveMessage: 'Unidentified error occurred', snackbarDuration: null });
    });
 
  }


}

CreatePayouts.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(CreatePayouts);
